import { render, staticRenderFns } from "./MenuItemOptionEditor.vue?vue&type=template&id=338914ae&scoped=true&"
import script from "./MenuItemOptionEditor.vue?vue&type=script&lang=js&"
export * from "./MenuItemOptionEditor.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemOptionEditor.vue?vue&type=style&index=0&id=338914ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338914ae",
  null
  
)

export default component.exports